<template>
    <div class="show">
        <portal to="actions">
            <div class="row">
                <div class="col-md-6 col-sm-12 mb-4 d-flex justify-content-lg-start justify-content-sm-center">
                    <button type="button" class="btn btn-primary" v-on:click="$router.back()">
                        <i class="fa fa-arrow-left mr-2"></i>
                        Back
                    </button>
                </div>
            </div>
        </portal>

        <div class="row mb-15">
            <div class="card mt-5 w-100">
                <div class="h5 p-4 border-bottom">User details</div>
                <div class="body p-4">
                    <div class="pb-4 border-bottom">
                        <div class="h6">
                            Name
                        </div>

                        <div>{{ user.first_name }} {{ user.last_name }}</div>
                    </div>

                    <div class="py-4 border-bottom">
                        <div class="h6">
                            Email
                        </div>

                        <div>{{ user.email }}</div>
                    </div>

                    <div class="pt-4">
                        <div class="h6">
                            Created at
                        </div>

                        <div>{{ user.created_at | format }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    import VueTable from '@components/table';

    import usersService from '@api/users';

    export default Vue.extend({
        components: {
            VueTable
        },
        data() {
            return {
                user: {},
                loading: {
                    user: true
                }
            };
        },
        filters: {
            format(date) {
                return moment(date).format('dddd, DD MMM YYYY [at] HH:mm');
            }
        },
        methods: {
            fetchUser() {
                this.loading.user = true;

                usersService
                    .get(this.$route.params.id)
                    .then((response) => {
                        this.user = response.data;
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    });
            }
        },
        mounted() {
            this.fetchUser();
        }
    });
</script>
